module.exports = __webpack_public_path__ + "img/icon-1.6aebf8f4.svg";